// extracted by mini-css-extract-plugin
export default {"create":"inSWDBoYeYaEtBR46C9P"};